import { MessageCircle } from "lucide-react";

// WhatsApp deeplink format: wa.me/<international number without + or leading 0>
// Swiss +41 79 396 66 60 → 41793966660
const WHATSAPP_NUMBER = "41793966660";
const DEFAULT_MESSAGE = "Hallo KK Academy, ich interessiere mich für eure Kurse / Workshops und hätte gerne mehr Infos.";

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Schreib uns auf WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 left-5 z-40 group inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebd5b] text-white shadow-lg shadow-emerald-900/30 rounded-full pl-3 pr-3 sm:pr-4 py-3 transition-all duration-200 hover:scale-105 hover:shadow-emerald-900/40"
    >
      <span className="relative inline-flex">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping opacity-50" aria-hidden />
        <MessageCircle className="w-5 h-5 relative" strokeWidth={2.4} />
      </span>
      <span className="hidden sm:inline text-sm font-medium tracking-wide">WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
